(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cam1-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.birdsnapCam1TrackingReady) return;
  window.birdsnapCam1TrackingReady = true;
  const sourceKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const incoming = new URLSearchParams(window.location.search);
  function safeValue(value) {
    return value && /^[a-zA-Z0-9_. -]{1,100}$/.test(value) ? value : null;
  }
  function publish(name, placement) {
    const config = document.getElementById('cam1-tracking-config');
    const payload = {product: 'cam1', placement: placement, theme_role: config?.dataset.themeRole || 'unknown'};
    window.dispatchEvent(new CustomEvent('birdsnap:cam1_tracking', {detail: {name: name, data: payload}}));
    if (payload.theme_role !== 'main') return;
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    try {
      const result = window.Shopify?.analytics?.publish('birdsnap:' + name, payload);
      if (result?.catch) result.catch(() => {});
    } catch (error) {}
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    if (link.getAttribute('href')?.startsWith('#') && !link.dataset.cam1Cta) return;
    let url;
    try {url = new URL(link.href, window.location.origin);} catch (error) {return;}
    const isEntry = url.origin === window.location.origin && (url.pathname === '/pages/birdsnap-cam-1' || url.searchParams.get('view') === 'cam1-preview');
    const cta = link.dataset.cam1Cta;
    if (isEntry && !cta) {
      const placement = link.dataset.cam1Entry || (link.closest('.banner') ? 'hero_banner' : link.closest('.rolling_slides') ? 'product_card' : link.closest('header, .header-main') ? 'navigation' : 'site_entry');
      url.searchParams.set('cam1_entry', placement);
      sourceKeys.forEach(key => {const value = safeValue(incoming.get(key)); if (value && !url.searchParams.has(key)) url.searchParams.set(key, value);});
      link.href = url.toString();
      publish('cam1_entry_click', placement);
    } else if (cta) {
      const isKickstarter = url.hostname === 'www.kickstarter.com' || url.hostname === 'kickstarter.com';
      if (isKickstarter) {
        const defaults = {utm_source: 'birdsnap', utm_medium: 'website', utm_campaign: 'cam1_launch', utm_content: cta};
        sourceKeys.forEach(key => {const value = safeValue(incoming.get(key)) || defaults[key]; if (value && !url.searchParams.has(key)) url.searchParams.set(key, value);});
        link.href = url.toString();
      }
      publish(isKickstarter ? 'cam1_kickstarter_click' : 'cam1_content_click', cta);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
